/* Wholesale inquiry form.
 *
 * Posts to the app proxy so the Klaviyo key and Slack notify stay server-side.
 * Client-side validation is a courtesy, not a control: everything here is
 * re-validated on the server, including the honeypot and the timing check.
 *
 * IIFE + per-node guard, since this section can render twice in the theme
 * editor. See reference_shopify_duplicate_section_script.
 */
(function () {
  'use strict';

  /* Path verified against the EU withdrawal precedent: the app proxy forwards
   * /apps/zuma-chat/<path> to the app's /<path>, and Remix maps the route file
   * api.wholesale-inquiry.tsx to /api/wholesale-inquiry. The /api/ segment is
   * required; omitting it 404s. */
  var ENDPOINT = '/apps/zuma-chat/api/wholesale-inquiry';
  var MIN_FILL_MS = 3000; /* a human cannot complete five fields faster */

  function setStatus(el, kind, message) {
    if (!el) return;
    el.textContent = message;
    el.className = 'wh-form__status wh-form__status--' + kind;
    el.hidden = false;
  }

  function initForm(form) {
    if (form.dataset.whReady === '1') return;
    form.dataset.whReady = '1';

    var statusEl = form.querySelector('[data-wh-status]');
    var submitBtn = form.querySelector('[data-wh-submit]');
    var renderedAt = form.querySelector('[data-wh-rendered]');
    var originalLabel = submitBtn ? submitBtn.textContent : '';

    if (renderedAt) renderedAt.value = String(Date.now());

    form.addEventListener('submit', function (e) {
      e.preventDefault();

      /* Native constraint validation, surfaced rather than replaced. */
      if (!form.checkValidity()) {
        var firstInvalid = form.querySelector(':invalid');
        if (firstInvalid) firstInvalid.focus();
        setStatus(statusEl, 'error', 'Check the highlighted fields and try again.');
        return;
      }

      var data = Object.fromEntries(new FormData(form).entries());

      /* Bot filters. Silent success on the honeypot so a bot gets no signal
       * about why it failed, and no real submission is created. */
      if (data.company_website) {
        setStatus(statusEl, 'ok', 'Inquiry sent. We will be in touch soon.');
        form.reset();
        return;
      }
      if (Date.now() - Number(data.rendered_at || 0) < MIN_FILL_MS) {
        setStatus(statusEl, 'error', 'That was quick. Give it another moment and resend.');
        return;
      }

      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = 'Sending';
      }

      fetch(ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          name: data.name,
          store_name: data.store_name,
          store_type: data.store_type,
          address: data.address || '',
          phone: data.phone,
          email: data.email,
          company_website: data.company_website || '',
          rendered_at: data.rendered_at,
        }),
      })
        .then(function (res) {
          if (!res.ok) throw new Error(String(res.status));
          return res.json().catch(function () {
            return {};
          });
        })
        .then(function () {
          /* Same vocabulary as the button: "Send inquiry" -> "Inquiry sent." */
          setStatus(statusEl, 'ok', 'Inquiry sent. We will be in touch soon.');
          form.reset();
          if (renderedAt) renderedAt.value = String(Date.now());
        })
        .catch(function () {
          setStatus(
            statusEl,
            'error',
            'That did not send. Email wholesale@zumanutrition.com and we will pick it up from there.'
          );
        })
        .finally(function () {
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.textContent = originalLabel;
          }
        });
    });
  }

  function boot() {
    document.querySelectorAll('[data-wh-inquiry]').forEach(initForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var form = e.target.querySelector('[data-wh-inquiry]');
    if (form) initForm(form);
  });
})();
